
function doLargeHeaderAnimations() {
	$('.bg-overlay').addClass('fadeOut'); // not working yet - trying to get background image to fade in but it's janky
	$('.inner-content.header').addClass('animate-fadeUp');
	$('.inner-content.header').addClass('animate-fadeIn');
	$('.inner-content.detail-bar').addClass('animate-fadeIn');
}

$( document ).ready(function() {
	doLargeHeaderAnimations();
});